<div #cardContainer class="adaptive-card"></div>